import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { PaymentModel } from 'src/app/admin-panel/models/business/payment.model';
import { DropdownHelperModel } from 'src/app/admin-panel/models/helpers/dropdown-helper.model';
import { ArchivePaymentComponent } from './archive-payment/archive-payment.component';
import { DetailsPaymentComponent } from './details-payment/details-payment.component';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent implements OnInit {

  //#region Fields
  public imagePath: string = './assets/images/icons/venue-logo-placeholder.png'
  public src_drop_opt: Array<DropdownHelperModel>;
  public src_drop_opt_1: DropdownHelperModel;
  public src_drop_opt_2: DropdownHelperModel;
  public selected_drop_opt: DropdownHelperModel;

  public paymentList: Array<PaymentModel>;
  public payment1: PaymentModel;
  public payment2: PaymentModel;
  public payment3: PaymentModel;
  //#endregion
  //#region Constructor
  constructor(public dialogService: DialogService) {
    this.src_drop_opt = new Array<DropdownHelperModel>();
    this.src_drop_opt_1 = new DropdownHelperModel()
    this.src_drop_opt_1.id = '1';
    this.src_drop_opt_1.name = 'A_Z';
    this.src_drop_opt_2 = new DropdownHelperModel()
    this.src_drop_opt_2.id = '2';
    this.src_drop_opt_2.name = 'Z_A';
    this.src_drop_opt.push(this.src_drop_opt_1);
    this.src_drop_opt.push(this.src_drop_opt_2);

    this.paymentList = new Array<PaymentModel>();

    this.payment1 = new PaymentModel();
    this.payment1.Id = "1";
    this.payment1.CompanyImagePath =this.imagePath;
    this.payment1.CompanyName = "Starcourt USA";
    this.payment1.CompanyWebSite="www.starcourt.com";
    this.payment1.ProcessDataName="Processor Name";
    this.payment1.PaymentDate="Wed, 23 Sep 2022 | 23:45 h";
    this.payment1.InstallmentName="Basic Member";
    this.payment1.InstallmentPrice="$300.00";
    this.payment1.PaymentPrice="$300.00";
    this.payment2 = new PaymentModel();
    this.payment2.Id = "2";
    this.payment2.CompanyImagePath =this.imagePath;
    this.payment2.CompanyName = "Starcourt USA";
    this.payment2.CompanyWebSite="www.starcourt.com";
    this.payment2.ProcessDataName="Processor Name";
    this.payment2.PaymentDate="Wed, 23 Sep 2022 | 23:45 h";
    this.payment2.InstallmentName="Basic Member";
    this.payment2.InstallmentPrice="$300.00";
    this.payment2.PaymentPrice="$300.00";
    this.payment3 = new PaymentModel();
    this.payment3.Id = "3";
    this.payment3.CompanyImagePath =this.imagePath;
    this.payment3.CompanyName = "Starcourt USA";
    this.payment3.CompanyWebSite="www.starcourt.com";
    this.payment3.ProcessDataName="Processor Name";
    this.payment3.PaymentDate="Wed, 23 Sep 2022 | 23:45 h";
    this.payment3.InstallmentName="Basic Member";
    this.payment3.InstallmentPrice="$300.00";
    this.payment3.PaymentPrice="$300.00";

    this.paymentList.push(this.payment1)
    this.paymentList.push(this.payment2)
    this.paymentList.push(this.payment3)
  }

  ngOnInit(): void {
  }
  //#endregion
  //#region Public Methods

  loadMorePayments() {

  }
  detailsPayment(id: string) {
    const ref = this.dialogService.open(DetailsPaymentComponent, {
      data: {
        id: id
      },
      header: 'Details Payment',
      width: '760px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  archivePayment(id: string) {
    const ref = this.dialogService.open(ArchivePaymentComponent, {
      data: {
        id: id
      },
      header: 'Archive Payment',
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  //#endregion
  //#Private Methods
  //#endregion
}
